import * as actionTypes from "../Actions/ActionTypes";

const initialState = {
    loading: false,
    personalDetails: {},
    usersProfileData: {},
    userProfileById: {}, // This is where user by ID data is stored
    contactedUsers: {},
    error: null,
    profileCreated: false,
    dropdown: []
};

const usersProfileReducer = (state = initialState, action) => {
    switch (action.type) {
        // get all users
        case actionTypes.GET_USERS_PROFILE_INIT:
            return {
                ...state,
                loading: true,
            };
        case actionTypes.GET_USERS_PROFILE_SUCCESS:
            return {
                ...state,
                loading: false,
                usersProfileData: action.payload,
                error: null,
            };
        case actionTypes.GET_USERS_PROFILE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        // user's personal details
        case actionTypes.USER_PERSONAL_DETAILS_INIT:
            return {
                ...state,
                loading: true,
            };
        case actionTypes.USER_PERSONAL_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                personalDetails: action.payload,
                error: null,
            };
        case actionTypes.USER_PERSONAL_DETAILS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        // user profile by id - FIXED: This stores data in userProfileById
        case actionTypes.GET_USERS_BYID_INIT:
            return {
                ...state,
                loading: true,
            };
        case actionTypes.GET_USERS_BYID_SUCCESS:
            return {
                ...state,
                loading: false,
                userProfileById: action.payload, // This is the correct property name
                error: null,
            };
        case actionTypes.GET_USERS_BYID_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        // get contacted users
        case actionTypes.GET_CONTACTED_USERS_INIT:
            return {
                ...state,
                loading: true,
            };
        case actionTypes.GET_CONTACTED_USERS_SUCCESS:
            return {
                ...state,
                loading: false,
                contactedUsers: action.payload,
                error: null,
            };
        case actionTypes.GET_CONTACTED_USERS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        // Add this case to your existing reducer
        case actionTypes.UPDATE_USER_PROFILE_INIT:
            return {
                ...state,
                loading: true,
            };
        case actionTypes.UPDATE_USER_PROFILE_SUCCESS:
            return {
                ...state,
                loading: false,
                userProfileById: action.payload, // Update the user data in state
                error: null,
            };
        case actionTypes.UPDATE_USER_PROFILE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        // DROPDOWN - REMOVED DUPLICATE GET_USERS_BYID CASES
        case actionTypes.DROPDOWN_INIT:
            return {
                ...state,
                loading: true,
            };
        case actionTypes.DROPDOWN_SUCCESS:
            return {
                ...state,
                loading: false,
                dropdown: action.payload,
                error: null,
            };
        case actionTypes.DROPDOWN_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default usersProfileReducer;